import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTable } from "@fortawesome/free-solid-svg-icons";
import {useTranslate} from "@tolgee/react";

const CsvDownload = () => {
    const {t} = useTranslate();

    const csvString = `Platform;Status;Date - Intl. format;Text;Media URL(s) - Separated by comma;Title - For the video, pin, PDF ..;Pin board;Post subtype - I.e. story, reel, PDF ..;CTA - Google;CTA - Google URL; First comment`;

    const handleDownload = () => {
        const BOM = "\uFEFF"; // UTF-8 Byte Order Mark
        const csvContent = BOM + csvString;

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "lomavis_bulk_upload_template.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    return (
        <Button variant="success" size={"sm"} onClick={handleDownload}>
            <FontAwesomeIcon icon={faTable} className="me-2" />
            {t("lomavisCreator.bulkPostsImportModal.downloadExampleCSV")}
        </Button>
    );
};

export default CsvDownload;
